var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEthernet = function SvgEthernet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.285,
    height: 49.285
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M43.34 0H5.943A5.95 5.95 0 0 0 0 5.943v37.4a5.95 5.95 0 0 0 5.943 5.945h37.4a5.95 5.95 0 0 0 5.943-5.945v-37.4A5.95 5.95 0 0 0 43.34 0m2.86 43.34a2.867 2.867 0 0 1-2.86 2.86H5.943a2.867 2.867 0 0 1-2.863-2.86V5.943A2.866 2.866 0 0 1 5.943 3.08h37.4A2.866 2.866 0 0 1 46.2 5.943v37.4Z",
    "data-name": "Path 55"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M43.122 4.622H6.16A1.54 1.54 0 0 0 4.622 6.16v20.022a1.54 1.54 0 0 0 1.54 1.54h7.7v6.161a1.54 1.54 0 0 0 1.54 1.54h18.481a1.54 1.54 0 0 0 1.54-1.54v-6.161h7.7a1.54 1.54 0 0 0 1.54-1.54V6.16a1.54 1.54 0 0 0-1.541-1.538m-1.538 20.02h-7.7a1.54 1.54 0 0 0-1.54 1.54v6.161h-15.4v-6.161a1.54 1.54 0 0 0-1.54-1.54h-7.7V7.7h33.88z",
    "data-name": "Path 56"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M36.964 6.163a1.54 1.54 0 0 0-1.54 1.54v7.7a1.54 1.54 0 1 0 3.08 0v-7.7a1.54 1.54 0 0 0-1.54-1.54",
    "data-name": "Path 57"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M36.964 18.482a1.54 1.54 0 0 0-1.54 1.54v1.54a1.54 1.54 0 1 0 3.08 0v-1.54a1.54 1.54 0 0 0-1.54-1.54",
    "data-name": "Path 58"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M12.321 6.163a1.54 1.54 0 0 0-1.54 1.54v7.7a1.54 1.54 0 1 0 3.08 0v-7.7a1.54 1.54 0 0 0-1.54-1.54",
    "data-name": "Path 59"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M12.321 18.482a1.54 1.54 0 0 0-1.54 1.54v1.54a1.54 1.54 0 1 0 3.08 0v-1.54a1.54 1.54 0 0 0-1.54-1.54",
    "data-name": "Path 60"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M18.482 6.163a1.54 1.54 0 0 0-1.54 1.54v7.7a1.54 1.54 0 0 0 3.08 0v-7.7a1.54 1.54 0 0 0-1.54-1.54",
    "data-name": "Path 61"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M18.482 18.482a1.54 1.54 0 0 0-1.54 1.54v1.54a1.54 1.54 0 1 0 3.08 0v-1.54a1.54 1.54 0 0 0-1.54-1.54",
    "data-name": "Path 62"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M24.642 6.163a1.54 1.54 0 0 0-1.54 1.54v7.7a1.54 1.54 0 0 0 3.08 0v-7.7a1.54 1.54 0 0 0-1.54-1.54",
    "data-name": "Path 63"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M24.642 18.482a1.54 1.54 0 0 0-1.54 1.54v1.54a1.54 1.54 0 1 0 3.08 0v-1.54a1.54 1.54 0 0 0-1.54-1.54",
    "data-name": "Path 64"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M30.803 6.163a1.54 1.54 0 0 0-1.54 1.54v7.7a1.54 1.54 0 0 0 3.08 0v-7.7a1.54 1.54 0 0 0-1.54-1.54",
    "data-name": "Path 65"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M30.803 18.482a1.54 1.54 0 0 0-1.54 1.54v1.54a1.54 1.54 0 1 0 3.08 0v-1.54a1.54 1.54 0 0 0-1.54-1.54",
    "data-name": "Path 66"
  })))));
};
export default SvgEthernet;